import { SetAuth } from "../helpers/Auth";
import { getEnviroments } from "../helpers/enviroments";

export const getArticle = async () => {
  try {
    const auth = SetAuth();
    const token = auth?.token;
    const { DOMAIN } = getEnviroments();

    const url = `${DOMAIN}/academia/articulo/api/`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    console.log('data.results', data.results)
    return data.results;
  } catch (error) {
    console.error("Error al obtener los articulos:", error);
    throw error;
  }
};